<template>
  <BModal
    active
    has-modal-card
    @close="() => $router.push({ name: 'Customers' })"
  >
    <form
      class="modal-card"
      @submit.prevent="create"
    >
      <header class="modal-card-head">
        <p class="modal-card-title has-text-primary">
          Nuevo cliente
        </p>
      </header>
      <section class="modal-card-body">
        <NewCustomer :loading="loading" />
      </section>
      <footer class="modal-card-foot">
        <RouterLink
          class="button"
          :to="{ name: 'Customers' }"
        >
          Cerrar
        </RouterLink>

        <button
          type="submit"
          class="button is-primary"
        >
          Crear cliente
        </Button>
      </footer>
    </form>
  </BModal>
</template>

<script>
export default {
  name: 'CustomerPush',
  components: {
    NewCustomer: () => import(/* webpackChunkName: "new-customer" */ '@/components/Admin/Customer/New.vue'),
  },
  data() { return { loading: false }; },
  methods: {
    async create(event) {
      event.stopPropagation();
      this.loading = true;
      try {
        await this.$store.dispatch('customers/create');
        this.$success({ message: 'Cliente creado exitosamente' });
        this.$router.push({ name: 'Customers' });
      } catch (error) {
        this.$danger({ message: error.message });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
form {
  width: auto;
}
</style>
